module.exports = __webpack_public_path__ + "static/media/jp-smiling.2c247416.png";